import React from "react";
import { Link } from "react-router-dom";
import COReport from "../pages/coreport";
import ReportsPage from "../pages/ReportsPage";
import type { PageKey } from "../lib/menu";

type ReportsViewProps = {
  isReportView: boolean;
  reportIdFromHash: string | null;
  authReady: boolean;
  activePage: PageKey;
  reportsView: "fakturor" | "klimat";
  rpFrom: string;
  rpTo: string;
  rpCustomerOpts: any[];
  rpSelectedCustomers: string[];
  setRpSelectedCustomers: React.Dispatch<React.SetStateAction<string[]>>;
  rpSelectedTypes: string[];
  setRpSelectedTypes: React.Dispatch<React.SetStateAction<string[]>>;
  rpTypeOpts: any[];
  setRpFrom: React.Dispatch<React.SetStateAction<string>>;
  setRpTo: React.Dispatch<React.SetStateAction<string>>;
};

export function ReportsView({
  isReportView,
  reportIdFromHash,
  authReady,
  activePage,
  reportsView,
  rpFrom,
  rpTo,
  rpCustomerOpts,
  rpSelectedCustomers,
  setRpSelectedCustomers,
  rpSelectedTypes,
  setRpSelectedTypes,
  rpTypeOpts,
  setRpFrom,
  setRpTo,
}: ReportsViewProps): JSX.Element | null {
  if (activePage !== "rapporter") return null;

  if (isReportView && reportIdFromHash) {
    return (
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: 16, color: "var(--text)" }}>
        <div style={{ marginBottom: 12 }}>
          <Link to="/rapporter" title="Till Rapporter" style={{ textDecoration: "none" }}>
            ← Till Rapporter
          </Link>
        </div>

        <ReportsPage reportId={reportIdFromHash!} authReady={authReady} />
      </div>
    );
  }

  return (
    <>
      {(() => { console.log("[render] RAPPORTER gate", { reportsView }); return null; })()}

      {reportsView === "fakturor" ? (
        <ReportsPage />
      ) : (
        <COReport
          from={rpFrom}
          to={rpTo}
          onChangeFrom={setRpFrom}
          onChangeTo={setRpTo}
          customerOpts={rpCustomerOpts}
          typeOpts={rpTypeOpts}
          selectedCustomers={rpSelectedCustomers}
          selectedTypes={rpSelectedTypes}
          onToggleCustomer={(key) =>
            setRpSelectedCustomers((prev) =>
              prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
            )
          }
          onToggleType={(id) =>
            setRpSelectedTypes((prev) =>
              prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
            )
          }
        />
      )}
    </>
  );
}
